module.exports = __webpack_public_path__ + "static/HydrolyzedCasein-82145a0b6a5fa2c67e039078d95b746a.webp";